import { Component, OnInit, OnDestroy } from '@angular/core';
import { ViewsService } from '@app/services/views.service';
import { TinyMCEOptions } from '@app/shared/tinymce_options';
import { CourseService } from '@scaffold/services/course.service';
import { ActivatedRoute } from '@angular/router';
import { ItemsService } from '@scaffold/services/items.service';
import { ViewUpdateService } from '@scaffold/services/view-update.service';
import { HttpUtilService } from '../../../services/http-util.service';
import { ScaffoldDialogRef } from '@app/framework/dialog/scaffold-dialog.service';
import { EnvironmentService } from '@services/environment.service';
import { CopyDataService } from '../../services/copy-data.service';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-add-data',
    templateUrl: './add-data.component.html',
    styleUrls: ['./add-data.component.scss'],
    standalone: false
})
export class AddDataComponent implements OnInit, OnDestroy {
  path = '';
  data: any = {};
  view = [];
  create = {
    id: null,
    type: null,
    data: {},
  };
  create_data: item_data = {};
  created = false;
  activeTab = 0;
  parent;
  opmPartners = [];
  opmPartnersOptions = [];
  partnerId = null;
  public saving: boolean = false;
  constructor(
    public dialogRef: ScaffoldDialogRef,
    public viewService: ViewsService,
    public editor: TinyMCEOptions,
    private courseService: CourseService,
    private route: ActivatedRoute,
    private itemsService: ItemsService,
    private viewUpdate: ViewUpdateService,
    private httpUtils: HttpUtilService,
    private environmentService: EnvironmentService,
    private copyDataService: CopyDataService
  ) {}

  ngOnDestroy() {
    this.itemsService.removeNewData(this.create.type);
  }

  ngOnInit() {
    console.log(this.data);
    this.create.type = this.data.type;
    if (this.data.duplicate) {
    }
    if (this.environmentService.environment.isOPM) {
      this.httpUtils
        .authGet(
          this.environmentService.environment.apiRoot +
            '/institution/opm-partners'
        )
        .subscribe(opmPartners => {
          this.opmPartners = opmPartners;
          this.opmPartnersOptions = [
            { id: null, name: 'none' },
            ...opmPartners,
          ];
        });
    }
    //pass is some predefined values in data.data as an object  {"key":value}
    if (this.data.data) {
      Object.keys(this.data.data).forEach(key => {
        this.setValue(key, this.data.data[key]);
      });
      this.triggerUpdate('editor change trigger');
    }
    console.log(this.create_data);
    if (this.data.comp && this.data.comp.route && this.data.comp.route.parent) {
      console.log('created by parent route');
      this.data.comp.route.parent.params.subscribe(params => {
        console.log('params', params);
        if (this.data.parent && this.data.parent.type && this.data.parent.id) {
          console.log('dta parent');
          this.path += this.data.parent.type + '/' + this.data.parent.id + '/';
          this.parent = {
            id: this.data.parent.id,
            type: this.data.parent.type,
          };
        } else if (params.type && params.id) {
          console.log('dta params');
          this.path = params.type + '/' + params.id + '/';
          this.parent = { id: params.id, type: params.type };
        }
        this.path += this.data.new_type || this.data.type;
        console.log(this.path);

        /* var url = params.type + "/" + params.id + "/" + this.data.type + "?mode=existing";
        if (this.data.allowExisting) {
          this.data.comp.courseService.get(url).subscribe(co => {
            if (co) {
              if (co.push) {
                this.view = co;
              } else {
                this.view = [co];
              }
            }
          });
        }*/

        var url2 = (this.data.new_type || this.data.type) + '/create';
        //  if (this.data.allowAdd) {
        this.data.comp.courseService.get(url2).subscribe(co => {
          console.log('GET', co);
          if (co && co.push) {
            // this.create.id = co[0].id
            // this.create.type = co[0].type;
            this.create.data = co[0].data;
          } else {
            if (co) {
              // this.create.id = co.id;
              //   this.create.type = co.type;
              this.create.data = co.data;
            }
          }
          console.log(this.create.data['content']);
          this.create_data = this.itemsService.getData(this.create);
          //pass is some predefined values in data.data as an object  {"key":value}
          if (this.data.data) {
            Object.keys(this.data.data).forEach(key => {
              this.itemsService.updateValue(
                key,
                this.data.data[key],
                this.create
              );
            });
            //this.triggerUpdate('editor change trigger');
          }
          console.log(this.create_data);
        });
        //   }
      });
    } else {
      this.path = '';
      if (this.data.parent && this.data.parent.type && this.data.parent.id) {
        this.parent = { id: this.data.parent.id, type: this.data.parent.type };
        this.path += this.data.parent.type + '/' + this.data.parent.id;
      } else if (this.courseService.id) {
        this.path += 'courses/' + this.courseService.id;
        this.parent = { id: this.courseService.id, type: 'courses' };
      }
      if (this.path.length > 0) this.path += '/';
      this.path += this.data?.new_type || this.data.type;
      console.log(this.path);

      //var url = this.path + "?mode=existing";
      /* if (this.data.allowExisting) {
         this.data.comp.courseService.get(url).subscribe(co => {
           if (co) {
             if (co.push) {
               this.view = co;
             } else {
               this.view = [co];
             }
           }

         });
       }*/
      var url2 = (this.data.new_type || this.data.type) + '/create';
      //  if (this.data.allowAdd) {
      this.courseService.get(url2).subscribe(co => {
        if (co && co.push) {
          this.create.data = co[0].data;
          // this.create.type = co[0].type;
        } else {
          if (co) this.create.data = co.data;
          //this.create.type = co.type;
        }
        this.create_data = this.itemsService.getData(this.create);
        //pass is some predefined values in data.data as an object  {"key":value}
        if (this.data.data) {
          Object.keys(this.data.data).forEach(key => {
            this.itemsService.updateValue(
              key,
              this.data.data[key],
              this.create
            );
            this.create_data[key] = this.data.data[key];
          });
          //this.triggerUpdate('editor change trigger');
        }
        console.log(this.create_data);
      });
      //  }
    }
  }

  get size() {
    return this.data?.size || 'wide';
  }
  createData(type) {
    if (!this.hasErrors()) {
      this.saving = true;
      if (!this.created) {
        delete this.create_data.data_input_error;
        // var children;
        var parents = {};
        delete this.create_data.child;

        if (
          this.data.comp.router &&
          !this.data.comp.router.url.includes(type) &&
          this.path.indexOf(this.data.comp.info.id) < 0
        ) {
          parents[this.data.comp.info.id] = 'parent';
        }

        if (
          this.data.comp.item &&
          this.data.comp.item.type === 'list' &&
          !this.create_data.hasOwnProperty('position')
        )
          this.create_data.position = this.data.comp.view.length + 1;

        let data = {
          type: type,
          data: this.create_data,
        };
        console.log(this.path);
        console.log(this.create_data);
        if (this.data.duplicate) {
          this.path += '?duplicate=' + this.data.duplicate.id;
        }
        if (this.partnerId != null) {
          this.path += `?partnerId=${this.partnerId}`;
        }
        if (this.create_data.copy_from || this.data.duplicate?.id) {
          let tocopy = this.create_data.copy_from || this.data.duplicate.id;
          this.copyDataService
            .initCopySocket(tocopy)
            .pipe(take(1))
            .subscribe(e => {
              let seperator = '?';
              if (this.path.match(/\?/)) {
                seperator = '&';
              }
              this.itemsService
                .createData(
                  this.path + seperator + 'connection=' + e,
                  data,
                  this.data.urlParams
                )
                .subscribe(d => {
                  this.saving = false;
                  // if no id, can assume it wasnt created
                  if (!d?.id) return;
                  this.created = true;
                  if (this.parent) {
                    this.viewUpdate.triggerListChange({
                      list_type: 'list',
                      type: d.type,
                      added: d.id,
                      parent_type: this.parent.type,
                      parent_id: this.parent.id,
                    });
                  } else {
                    this.viewUpdate.triggerListChange({
                      list_type: 'list',
                      type: d.type,
                      added: d.id,
                      parent_type: null,
                      parent_id: null,
                    });
                  }
                  this.dialogRef.close(d);
                });
            });
        } else {
          this.itemsService
            .createData(this.path, data, this.data.urlParams)
            .subscribe(d => {
              this.saving = false;
              // if no id, can assume it wasnt created
              if (!d?.id) return;
              this.created = true;
              if (this.parent) {
                this.viewUpdate.triggerListChange({
                  list_type: 'list',
                  type: d.type,
                  added: d.id,
                  parent_type: this.parent.type,
                  parent_id: this.parent.id,
                });
              } else {
                this.viewUpdate.triggerListChange({
                  list_type: 'list',
                  type: d.type,
                  added: d.id,
                  parent_type: null,
                  parent_id: null,
                });
              }
              this.dialogRef.close(d);
            });
        }
      }
    }
  }

  setValue(setting, value) {
    this.itemsService.updateValue(setting, value, this.create);
    //this.forceRequiredCheck(setting);
  }
  /*
  forceRequiredCheck(setting) {
    console.log(this.create_data)
    if (this.create_data.data_input_error && this.create_data.data_input_error[setting] == 'Required') {
      delete this.create_data.data_input_error[setting];
      var count = 0;
      var keys = Object.keys(this.create_data.data_input_error)
      console.log(keys);
      keys.forEach(key => {
        if (this.create_data.data_input_error.hasOwnProperty(key)) {
          count++;
        }
      })
      console.log(count)
      if (count == 0) {
        delete this.create_data.data_input_error;
      }
    }
  }*/

  checkKeys(obj): boolean {
    return true;
  }

  hasErrors() {
    return this.itemsService.disableSave(this.create.type);
  }

  triggerUpdate(e?) {
    // console.log(e);
    try {
      this.viewUpdate.triggerChangePropagation(e);
    } catch (e) {
      //  console.log(e)
    }
  }
}

class item_data {
  child?;
  position?;
  content_id?;
  type?;
  reference_id?;
  data_input_error?;
  copy_from?;
}
